const common = require('angular').module('oly.common');

const inputDirectives = require('./input.directive');

common.directive('wowInputContainer', ['$parse', inputDirectives.inputContainer]);
common.directive('label', [inputDirectives.label]);
common.directive('input', ['GuidFactory', inputDirectives.input]);
common.directive('textarea', ['GuidFactory', inputDirectives.input]);
common.directive('placeholder', [inputDirectives.placeholder]);



// WEBPACK FOOTER //
// ./src/olycommon/input/index.js